import React from 'react';

// Shared section shell: every block gets the same banded header so a page scans
// as a set of named sections.
//
// Two tones on purpose. `gradient` is the loud one — use it where a page has a
// couple of sections (Configuración). `soft` is the same band at 5% and is the
// default, because a column of five stacked gradient bars reads as a wall of
// blue; it also matches the Proyectos tab and ProveedorCard, whose bodies are
// tables that already carry a gradient header of their own.
const TONES = {
  soft: {
    band: 'bg-azul-surelia/5 border-b border-azul-surelia/10',
    title: 'text-azul-surelia',
    icon: 'text-azul-surelia/70',
  },
  gradient: {
    band: 'bg-gradient-to-r from-azul-surelia to-azul-surelia/95',
    title: 'text-white',
    icon: 'text-white/80',
  },
};

const SectionCard = ({ icon: Icon, title, action, children, bodyClassName = 'p-5', tone = 'soft' }) => {
  const t = TONES[tone] || TONES.soft;
  return (
    <div className="bg-white rounded-lg shadow-sm border border-azul-surelia/15 overflow-hidden">
      <div className={`px-5 py-3 flex items-center justify-between gap-2 ${t.band}`}>
        <span className={`font-semibold text-sm flex items-center gap-2 ${t.title}`}>
          {Icon && <Icon className={`w-4 h-4 ${t.icon}`} />}
          {title}
        </span>
        {action}
      </div>
      <div className={bodyClassName}>{children}</div>
    </div>
  );
};

export default SectionCard;
